module.exports = __webpack_public_path__ + "static/media/broszura_IFA_1_A.83dbbae9.png";